// 공통 zod 스키마.
// 사용자 앱/관리자 콘솔/API 가 동일한 도메인 검증 규칙을 공유하도록 본 파일에 모은다.
// 실제 엔드포인트별 요청/응답 스키마는 Phase 1~3 진행 중 점진적으로 추가한다.
// 본 파일은 Phase 0 단계의 골격이며, 단위/주문 상태 검증의 기본 사용 예만 보여준다.

import { z } from "zod";
import { unitCodeSchema } from "./units.js";
import { ORDER_STATUS, type OrderStatus } from "./orderStatus.js";

// 상품 단위 스키마.
// 단위가 DB 관리로 승격되어(마이그 0022) 코드 형식만 검증한다.
// 실제 단위 코드가 units 테이블에 존재하는지는 API 레이어(상품 생성/수정)에서 DB 로 검증한다.
export const productUnitSchema = unitCodeSchema;

// 주문 상태 스키마.
// 외부 입력으로 들어오는 상태 값을 검증할 때 사용한다. 상태 전환 가능성은 별도 함수에서 검증.
export const orderStatusSchema = z.enum([
  ORDER_STATUS.RECEIVED,
  ORDER_STATUS.ACCEPTED,
  ORDER_STATUS.REJECTED,
  ORDER_STATUS.PREPARING,
  ORDER_STATUS.READY,
  ORDER_STATUS.COMPLETED,
  ORDER_STATUS.CANCELED,
]) satisfies z.ZodType<OrderStatus>;

// 국내 휴대폰 번호 형식 검증.
// 가입/배달 주소 등에서 사용. DB 저장 시 하이픈 제거된 정규형으로 변환하는 것을 권장.
export const phoneNumberKrSchema = z
  .string()
  .trim()
  .regex(/^01[0-9]-?\d{3,4}-?\d{4}$/u, "휴대폰 번호 형식이 올바르지 않습니다.");

// 국내 휴대폰 번호 정규형(하이픈 제거, 11자리) 으로 변환한다.
// DB 저장/조회 키로 사용하므로 모든 진입점(폼/OTP/주문 주소) 에서 본 함수를 통과시킨다.
// 입력이 유효 형식이 아니면 null 을 반환하고, 호출자는 검증 실패로 처리한다.
export function normalizePhoneKr(input: string): string | null {
  const trimmed = input.trim();
  const digits = trimmed.replace(/[\s-]/gu, "");
  if (!/^01[0-9]\d{7,8}$/u.test(digits)) {
    return null;
  }
  return digits;
}

// 양수 금액(원) 검증. 부동소수점 회피를 위해 정수 단위로 다룬다.
export const positiveAmountKrwSchema = z.number().int().nonnegative();
